<template>
  <SelectItem
    v-bind="forwardedProps"
    :class="cn(itemVariant({ size: variants.size }), props.class)"
  >
    <span class="absolute right-2 flex h-3.5 w-3.5 items-center justify-center">
      <SelectItemIndicator>
        <Check class="h-4 w-4 text-accent-400" />
      </SelectItemIndicator>
    </span>

    <SelectItemText>
      <slot />
    </SelectItemText>
  </SelectItem>
</template>

<script setup>
import { computed, inject } from 'vue';
import {
  SelectItem,
  SelectItemIndicator,
  SelectItemText,
  useForwardProps,
} from 'radix-vue';
import { Check } from 'lucide-vue-next';
import { cva } from 'class-variance-authority';
import { cn } from '../../utils.js';

const props = defineProps({});

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});

const variants = inject('select-variants');

const itemVariant = cva(
  [
    'relative flex w-full cursor-pointer data-[highlighted]:bg-neutral-50/[0.12]',
    'select-none items-center rounded-sm px-3 py-2 text-sm outline-none',
    'data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
    'data-[state=checked]:bg-neutral-50/[0.16]',
  ],
  {
    variants: {
      size: {
        sm: '[&:not(:last-child)]:mb-1',
        lg: '[&:not(:last-child)]:mb-1',
        xl: '[&:not(:last-child)]:mb-2',
      },
    },
    defaultVariants: {
      size: 'lg',
    },
  }
);

const forwardedProps = useForwardProps(delegatedProps);
</script>
